import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserData } from 'Services/API';
import { useTranslation } from 'react-i18next';
import { openViewAssignmentsModal } from '../tutorAssignmentSlice/tutorAssignmentSlice';
import './ViewAssignmentsModalButton.scss';
export default function ViewAssignmentsModalButton() {
  const { t } = useTranslation("tutor_assignment_modal");
  const dispatch = useDispatch();
  const roster = useSelector(state => state.reports.roster)
  const handleOpenViewAssignmentsModal = () => {
    dispatch(openViewAssignmentsModal())
  }

  const isButtonDisabled = (roster) => {
    const isRosterEmpty = Object.keys(roster).length === 0;
    const isRosterPending = roster.status && roster.status.type !== "COMPLETE";
    return isRosterEmpty || isRosterPending;
  };

  const { tutorAssignmentEnabled } = getUserData()
  if (!tutorAssignmentEnabled) return null;

  return <button className='view-tutor-assignments-button' onClick={handleOpenViewAssignmentsModal} disabled={isButtonDisabled(roster)}>{t('see_assignments')}</button>
}
